import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextField, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import APIService from '../services/APIService';
import Loading from './Loading';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    paper: {
        position: 'absolute',
        width: theme.spacing.unit * 50,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    },
});

class MenuRemover extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: props.open,

            from: null,
            to: null,

            types: [],
        };
    }

    remove() {
        if (!confirm(this.props.t('Haluatko varmasti poistaa kaikki ruokalistat syötetyltä aikaväliltä valitsemastasi toimipaikoista?'))) {
            return;
        }

        let restaurantIds = Array.isArray(this.props.restaurantIds) ? this.props.restaurantIds : [this.props.restaurantIds];
        restaurantIds.forEach(restaurantId => {
            APIService.destroyMenuBetween(restaurantId, this.state.from, this.state.to);
            this.props.onClose();
        });
    }

    render() {
        const { classes } = this.props;

        if (this.state.loading) {
            return <Loading/>;
        }

        return (
            <Modal
                open={this.props.open}
                onClose={this.props.onClose}
            >
                <div className={classes.paper}>
                    <Grid container spacing={24}>
                        <Grid item xs={12}>
                            <Typography variant="title">{this.props.t('Poista ruokalistoja aikaväliltä')}</Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                type="date"
                                label={this.props.t('Päivämäärästä')}
                                value={this.state.from}
                                onChange={(event) => this.setState({from: event.target.value})}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                type="date"
                                label={this.props.t('Päivämäärään')}
                                value={this.state.to}
                                onChange={(event) => this.setState({to: event.target.value})}
                            />
                        </Grid>

                        <Grid item xs={12} style={{textAlign: 'right'}}>
                            <Button
                                color="primary"
                                disabled={!(this.state.from && this.state.to)}
                                onClick={() => this.remove()}
                            >
                                {this.props.t('Poista')}
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </Modal>
        );
    }
}

MenuRemover.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(MenuRemover));



// WEBPACK FOOTER //
// ./resources/assets/js/components/MenuRemover.js